// Polyfills for IE11 (optional if you still need to support legacy browsers)
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

// 3rd-party CSS imports
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-quill/dist/quill.snow.css';
import 'nprogress/nprogress.css';

import { enableES5 } from 'immer';  // TODO_SP: // Only needed if you support IE11 or older environments
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import * as serviceWorker from 'src/serviceWorker';
import { configureStore } from 'src/store';
import { restoreSettings } from 'src/utils/settings';
import { SettingsProvider } from 'src/context/SettingsContext';
import App from 'src/App';

enableES5();   // TODO_SP // // keep if you're supporting IE or really old Android/iOS

const store = configureStore();
const settings = restoreSettings();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <SettingsProvider settings={settings}>
        <App />
      </SettingsProvider>
    </Provider>
  </React.StrictMode>
);

// TODO_SP // Unregister service worker by default; change to `register()` if you need offline support
serviceWorker.unregister();
